export const UserModelModule = angular
    .module('app.services.model.models.userModel', [])
    .value('userModel', {
        firstName: 'String',
        lastName: 'String',
        phoneNumber: 'String',
        email: 'String'
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/data/model/models/user.model.js